<div id="content">
  <img src="../../assets/devArchiTech.png" style="height: 35px;">
</div>
